import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { AppSettings } from '../../app.settings';
import { ScopedAccessApi, ScopedCatalog, ScopedCompany, ScopedGrant, ScopedMutation, ScopedPage } from './scoped-access.models';
import { SCOPED_ACCESS_CURRENT } from './scoped-access-request';

@Injectable({providedIn: 'root'})
export class ScopedAccessService implements ScopedAccessApi {
  constructor(private http: HttpClient) {}

  companies(current: () => boolean): Promise<ScopedCompany[]> {
    // Same existing company-list contract, scoped transport only for this dialog.
    return this.http.get<ScopedCompany[]>(`${AppSettings.getEndpoint()}teams/companies/role/supportmanager`,
      this.options(current)).toPromise();
  }

  catalog(current: () => boolean): Promise<ScopedCatalog> {
    return this.http.get<ScopedCatalog>(this.url('management-catalog'), this.options(current)).toPromise();
  }

  list(subject: string, history: boolean, cursor: string | null, current: () => boolean): Promise<ScopedPage> {
    return this.http.get<ScopedPage>(this.url(`subjects/human_user/${encodeURIComponent(subject)}/role-bundle-assignments`), {
      ...this.options(current), params: {limit: '25', includeHistory: String(history), ...(cursor ? {cursor} : {})},
    }).toPromise();
  }

  grant(subject: string, body: ScopedGrant, key: string, current: () => boolean): Promise<ScopedMutation> {
    return this.http.post<ScopedMutation>(this.url(`subjects/human_user/${encodeURIComponent(subject)}/role-bundle-assignments`),
      body, this.options(current, key)).toPromise();
  }

  revoke(id: string, body: {expectedCatalogVersion: string}, key: string, current: () => boolean): Promise<ScopedMutation> {
    return this.http.post<ScopedMutation>(this.url(`role-bundle-assignments/${encodeURIComponent(id)}/revocations`),
      body, this.options(current, key)).toPromise();
  }

  private url(path: string): string { return `${AppSettings.getEndpoint()}v5/admin-authorization/${path}`; }

  private options(current: () => boolean, key?: string): {context: HttpContext; headers: HttpHeaders} {
    return {context: new HttpContext().set(SCOPED_ACCESS_CURRENT, current),
      headers: new HttpHeaders(key ? {'Idempotency-Key': key} : {})};
  }
}
